import { createContext, useContext, useState } from "react";

const EstimateContext = createContext(null);

export const EstimateProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openEstimate = () => setOpen(true);
  return (
    <EstimateContext.Provider value={{ open, setOpen, openEstimate }}>
      {children}
    </EstimateContext.Provider>
  );
};

export const useEstimate = () => useContext(EstimateContext);
